<div class="modal-header">
    <h4 class="modal-title pull-left">Edit Profile</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body ml-1">
    <div class="form-row form-background-header">
        <div class="col-md-12" style="font-size: 16px;">
            <div id="registration" style="display: block;">
                <form #f="ngForm" [formGroup]="profileForm" (submit)="updateProfile()">

                    <div class="form-group">
                        <div *ngIf="profileForm.controls.firstName.dirty && profileForm.controls.firstName.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.firstName.errors.required">First Name is required
                            </div>
                        </div>
                        <div class="col-12">
                            <input type="text" id="fname" class="form-control" placeholder="First Name"
                                formControlName="firstName">
                        </div>
                    </div>

                    <div class="form-group">
                        <div *ngIf="profileForm.controls.lastName.dirty && profileForm.controls.lastName.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.lastName.errors.required">Last Name is required
                            </div>
                        </div>
                        <div class="col-12">
                            <input type="text" id="lname" class="form-control" placeholder="Last Name"
                                formControlName="lastName">
                        </div>
                    </div>

                    <div class="form-group">
                        <div *ngIf="profileForm.controls.phone.dirty && profileForm.controls.phone.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.phone.errors.required">Phone Number is required
                            </div>
                        </div>
                        <div class="col-12">
                            <input type="text" id="phone" class="form-control" placeholder="Phone"
                                formControlName="phone">
                        </div>
                    </div>

                    <div class="form-group">
                        <div *ngIf="profileForm.controls.newPassword.dirty && profileForm.controls.newPassword.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.newPassword.errors.required">New Password is required
                            </div>
                        </div>
                        <div class="col-12">
                            <input [type]="showPass.checked ? 'text' : 'password'" id="password" class="form-control"
                                placeholder="New Password" formControlName="newPassword">
                        </div>
                    </div>

                    <div class="form-group text-left">
                        <div *ngIf="profileForm.controls.repassword.dirty && profileForm.controls.repassword.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.repassword.errors.required">Confirm Password is required
                            </div>
                            <div *ngIf="profileForm.controls.repassword.errors.mustMatch">Passwords must match</div>
                        </div>
                        <div class="col-12">
                            <input [type]="showPass.checked ? 'text' : 'password'" id="repassword" class="form-control"
                                placeholder="Re-enter Password" formControlName="repassword">
                        </div>

                    </div>

                    <div class="form-group">
                        <div *ngIf="profileForm.controls.password.dirty && profileForm.controls.password.errors"
                            style="color: red; font-size: xx-small; margin-left: 20px;">
                            <div *ngIf="profileForm.controls.password.errors.required">Current Password is required
                            </div>
                        </div>
                        <div class="col-12">
                            <input [type]="showPass.checked ? 'text' : 'password'" id="old_password"
                                class="form-control" placeholder="Current Password" formControlName="password">

                            <input type="checkbox" #showPass (change)="0" class="ml-2"> Show Password <small
                                class="text-muted"></small>
                        </div>
                    </div>


                    <br>

                </form>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-m btn-success mr-1" [disabled]="!profileForm.valid"
        (click)="updateProfile()">Update</button>
    <button class="btn btn-m btn-warning mr-1" (click)="closeModal()">Close</button>
</div>